var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.621,
    height: 14.676,
    viewBox: "0 0 12.621 14.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-1508.824 -477.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    "data-name": "Path 3830",
    d: "M12.994,14.787H4.189V5H3.21V15.766H13.973V5h-.978Z",
    transform: "translate(1506.495 476.088)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 0.978,
    height: 7.729,
    transform: "translate(1514.597 482.266)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159",
    transform: "translate(1511.857 482.266)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 0.978,
    height: 7.729,
    transform: "translate(5.479)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 0.978,
    height: 7.729,
    fill: "#717171"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    "data-name": "Path 3831",
    d: "M10.664,2.6V.736h-4.3V2.6H2.25v.979H14.871V2.6ZM7.338,1.715H9.783V2.6H7.338Z",
    transform: "translate(1506.574 476.441)",
    fill: "#717171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c0f7be7ae7a6ed49904dcb30c591682a.svg";
export { ForwardRef as ReactComponent };